import { type FC } from "react";
import { Navigate } from "react-router-dom";

import { Alert, Button, Status } from "@snapchat/snap-design-system";

import { useV3Routes } from "../../core/routes/hooks";
import { PageHeader, PageHeaderContainer } from "../../layout/components";
import { AssetLibraryTitle } from "../../layout/components/messages.generated";
import { Flexbox } from "../../shared/components";
import { usePageRedirect } from "../../shared/hooks";
import { Feature } from "../../shared/models";
import { useOrgForMigratedAssets, useOrganizationAssets } from "../hooks";

import { BoldText, alertStyle } from "./AssetsList.styles";
import { AssetsTable } from "./AssetsTable";
import { NewAssetButtonText, Notice, NoticeBody } from "./messages.generated";

export const AssetsList: FC = () => {
    const { organizationAssets, loading: orgAssetsLoading, total: orgAssetsTotal } = useOrganizationAssets();
    const { hasMigratedAssets, organizationName, assets } = useOrgForMigratedAssets();
    const { goToAssetSubmission } = useV3Routes();
    const redirect = usePageRedirect(Feature.assets);

    if (redirect) {
        return <Navigate to={redirect} />;
    }

    return (
        <div>
            <Flexbox justifyContent="space-between">
                <PageHeaderContainer>
                    <PageHeader>
                        <AssetLibraryTitle />
                    </PageHeader>
                </PageHeaderContainer>
                <Button onClick={goToAssetSubmission} type="primary">
                    {<NewAssetButtonText />}
                </Button>
            </Flexbox>
            {hasMigratedAssets && (
                <div>
                    <Alert
                        className={alertStyle}
                        title={<Notice />}
                        status={Status.INFO}
                        message={
                            <NoticeBody
                                assets={<BoldText>{assets.join(", ")}</BoldText>}
                                organization={<BoldText>{organizationName}</BoldText>}
                            />
                        }
                    ></Alert>
                </div>
            )}
            <AssetsTable assets={organizationAssets} loading={orgAssetsLoading} total={orgAssetsTotal} />
        </div>
    );
};
